import { render, staticRenderFns } from "./AffairsSection.vue?vue&type=template&id=cecb63c4&scoped=true"
import script from "./AffairsSection.vue?vue&type=script&lang=js"
export * from "./AffairsSection.vue?vue&type=script&lang=js"
import style0 from "./AffairsSection.vue?vue&type=style&index=0&id=cecb63c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cecb63c4",
  null
  
)

export default component.exports